// ======================================================================
// File Name       : GroupNotAdminRelation
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Table, Form } from 'react-bootstrap';
import * as commonUtils from '../../utils';
import { USER_TYPE_DISPLAY_LIST } from '../../constants/UserConstants';

class GroupNotAdminRelation extends Component {
  render() {
    const { editingUserGroupNotAdmin } = this.props;

    return (
      <Form.Group>
        <Col sm={12} className="margin-top-20">所属受講ユーザー</Col>
        <Col sm={12}>
          <Table striped hover className="margin-top-7 margin-bottom-0">
            <thead>
              <tr>
                <th>ユーザー種別</th>
                <th>ユーザー名</th>
                <th>ログインID</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(editingUserGroupNotAdmin).map((userSecernId, index) => {
                const data = editingUserGroupNotAdmin[userSecernId];
                return (
                  <tr key={index}>
                    <td>{commonUtils.getItemBoxName(USER_TYPE_DISPLAY_LIST, data.userType)}</td>
                    <td>{data.userName}</td>
                    <td>{data.loginId}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Form.Group>
    );
  }
}

GroupNotAdminRelation.propTypes = {
  editingUserGroupNotAdmin: PropTypes.shape().isRequired,
};

export default GroupNotAdminRelation;
